exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".external-call-container[data-v-0bba0639]{position:relative}.external-call-container .menu-tab[data-v-0bba0639]  .el-tabs__item{height:50px !important;line-height:50px !important}.external-call-container .loading[data-v-0bba0639]{width:100%;min-height:600px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:absolute}", ""]);

// exports
